import { render } from "./KnoppenBord.vue?vue&type=template&id=b863e48a&scoped=true"
import script from "./KnoppenBord.vue?vue&type=script&lang=js"
export * from "./KnoppenBord.vue?vue&type=script&lang=js"

import "./KnoppenBord.vue?vue&type=style&index=0&id=b863e48a&scoped=true&lang=css"

import exportComponent from "/home/hans/projecten/zwart-av/switcher/software/switcher-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b863e48a"]])

export default __exports__